import { Children, cloneElement, FC, isValidElement, useEffect, useMemo, useState } from 'react';
import { StyledBlurredModal } from 'src/features/character/components/BlurredModal/BlurredModal.styles';
import Portal from '../Portal';
import { StyledImageMagnifier } from './ImageMagnifier.styles';
import { IImageMagnifier } from './ImageMagnifier.type';

const inlineCursor = { cursor: 'zoom-out' };

const ImageMagnifier: FC<IImageMagnifier> = ({ children }) => {
	const [isMounted, setIsMounted] = useState(false);
	const [isVisible, setIsVisible] = useState(false);

	const childrenWithListener = useMemo(
		() =>
			Children.map(children, (child) => {
				if (isValidElement(child)) {
					return cloneElement(child, {
						// @ts-ignore
						onClick: () => setIsMounted(true),
						style: { cursor: 'zoom-in' }
					});
				}
				return child;
			}),
		[children]
	);

	const childrenMagnified = useMemo(
		() =>
			Children.map(children, (child) => {
				if (isValidElement(child)) {
					return cloneElement(child, {
						// @ts-ignore
						width: undefined,
						height: undefined,
						layout: 'fill',
						objectFit: 'contain'
					});
				}
				return child;
			}),
		[children]
	);

	useEffect(() => {
		let timeout: NodeJS.Timeout | undefined;

		if (isMounted) {
			timeout = setTimeout(() => {
				setIsVisible(true);
			}, 10);
		}

		return () => clearTimeout(timeout);
	}, [isMounted]);

	useEffect(() => {
		let timeout: NodeJS.Timeout | undefined;

		if (!isVisible && isMounted) {
			timeout = setTimeout(() => {
				setIsMounted(false);
			}, 250);
		}

		return () => clearTimeout(timeout);
	}, [isMounted, isVisible]);

	return (
		<>
			{childrenWithListener}

			{isMounted && (
				<Portal>
					<StyledBlurredModal
						className='modal-background'
						isVisible={isVisible}
						onClick={() => setIsVisible(false)}
						style={inlineCursor}
					>
						<StyledImageMagnifier className='child-animated'>{childrenMagnified}</StyledImageMagnifier>
					</StyledBlurredModal>
				</Portal>
			)}
		</>
	);
};

export { ImageMagnifier };
